import React from 'react';
import Modal from '@lib/components/common/Modal';
import Button from '@lib/components/common/Button';

export default class TransformToProductionOrderInformationModal extends React.Component {
    render() {
        return (
            <Modal isOpen={this.props.isOpen}>
                <Modal.Header>{__('Transform to production order')}</Modal.Header>
                <Modal.Body>
                    {__('Transform to production order will be split between different production sites. Do you agree?')}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.onYesClick}>{__('Yes')}</Button>
                    <Button onClick={this.props.onNoClick}>{__('No')}</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}